import { lazy, Suspense } from 'react';
import { motion } from 'framer-motion';
import { FiMail } from 'react-icons/fi';
import { FaLinkedin } from 'react-icons/fa';
import { AiFillGithub } from 'react-icons/ai';
import { profile } from '../../../data/profile';
import { useReducedMotion } from '../../../hooks/useReducedMotion';
import './contact.scss';

const WaveformBackground = lazy(() => import('./WaveformBackground'));

export default function Contact() {
  const reduced = useReducedMotion();

  return (
    <section className="contact" id="contact">
      <div className="contact__canvas">
        {!reduced && (
          <Suspense fallback={null}>
            <WaveformBackground />
          </Suspense>
        )}
      </div>
      <div className="contact__content">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="contact__eyebrow"
        >
          Get in touch
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.25, 1, 0.5, 1] }}
          className="contact__title"
        >
          Let's make something.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="contact__subtitle"
        >
          AI products, web work, or music collaborations — always open to a conversation.
        </motion.p>
        <div className="contact__links">
          <a className="contact__link" href={`mailto:${profile.email}`}>
            <FiMail /> {profile.email}
          </a>
          <a className="contact__link" href={profile.links.linkedin} target="_blank" rel="noreferrer">
            <FaLinkedin /> LinkedIn
          </a>
          <a className="contact__link" href={profile.links.github} target="_blank" rel="noreferrer">
            <AiFillGithub /> GitHub
          </a>
        </div>
      </div>
    </section>
  );
}
